import {
  array,
  object,
} from 'yup'

import { genArgConverter } from '../../../utils'
import { i18nErrorCodes }  from '../form-utils'

const {
  required,
  minOneEducationalAchievementRequired,
} = i18nErrorCodes

export default object().shape({
  education: array()
               .min(1, minOneEducationalAchievementRequired)
               .required(required),
})

export const convertToEditEducation = genArgConverter(
  (type, { education }) => [
    type,
    education,
  ]
)

export const convertEducation = ({
  education
}) => ({
  studies: education,
})

export const emptyEducation = {
  education: [],
}



// WEBPACK FOOTER //
// ./src/components/forms/schemas/education.schema.ts